import React, { ReactNode } from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { connect } from 'react-redux';

import { StoreI } from '~src/rootReducer';

interface StateProps {
  redirect: string | null;
}

interface OwnProps extends RouteProps {
  isAuthenticated: boolean;
}

type Props = OwnProps & StateProps;

class Public extends React.Component<Props> {
  static defaultProps = {
    redirect: '/',
  };

  renderRoute = (props: RouteComponentProps<any>): ReactNode => {
    const { isAuthenticated, component, redirect, render } = this.props;
    if (!isAuthenticated) {
      return component
        ? React.createElement(component, {
            ...props,
            isAuthenticated,
          })
        : render && render(props);
    } else {
      return <Redirect to={redirect || '/'} />;
    }
  };

  render() {
    const { isAuthenticated, component, render, ...rest } = this.props;
    return <Route {...rest} render={this.renderRoute} />;
  }
}

const mapState2Props = ({ user }: StoreI): StateProps => ({
  redirect: user.session.redirect,
});

const PublicC = connect(mapState2Props)(Public);

export default PublicC;
